import { saveAs } from 'file-saver';

export interface ExcelExportConfig {
  data: any[];
  columns: {
    key: string;
    label: string;
    formatter?: (value: any, row: any) => string;
  }[];
  fileName: string;
  sheetName?: string;
}

/**
 * Export data to Excel (.xls format using HTML table)
 * @param config - Export configuration
 */
export const exportToExcel = (config: ExcelExportConfig) => {
  const { data, columns, fileName } = config;

  // Create HTML table
  let html = '<html><head><meta charset="UTF-8"></head><body>';
  html += '<table border="1" cellpadding="5" cellspacing="0">';
  
  // Add headers
  html += '<tr>';
  columns.forEach((col) => {
    html += `<th>${col.label}</th>`;
  });
  html += '</tr>';

  // Add data rows
  data.forEach((row) => {
    html += '<tr>';
    columns.forEach((col) => {
      let value = row[col.key];

      if (col.formatter) {
        value = col.formatter(value, row);
      }

      const displayValue = value != null ? String(value) : '';
      html += `<td>${displayValue}</td>`;
    });
    html += '</tr>';
  });

  html += '</table></body></html>';

  const BOM = '\uFEFF';
  const blob = new Blob([BOM + html], {
    type: 'application/vnd.ms-excel;charset=utf-8;',
  });

  // Generate filename with timestamp
  const timestamp = new Date().toISOString().slice(0, 10);
  const fullFileName = `${fileName}_${timestamp}.xls`;

  // Save file
  saveAs(blob, fullFileName);
};

/**
 * Alternative export using XLSX-style formatting (for future enhancement)
 * This version creates a more Excel-friendly CSV with proper formatting
 */
export const exportToExcelAdvanced = (config: ExcelExportConfig) => {
  const { data, columns, fileName } = config;

  // Create headers with auto-width optimization
  const headers = columns.map((col) => col.label);

  // Create data rows
  const rows = data.map((row) =>
    columns.map((col) => {
      let value = row[col.key];

      if (col.formatter) {
        value = col.formatter(value, row);
      }

      return value != null ? String(value) : '';
    })
  );

  // Create TSV content (Tab-Separated Values) for better Excel compatibility
  const tsvContent = [
    headers.join('\t'),
    ...rows.map((row) => row.join('\t')),
  ].join('\n');

  const BOM = '\uFEFF';
  const blob = new Blob([BOM + tsvContent], {
    type: 'application/vnd.ms-excel;charset=utf-8;',
  });

  const timestamp = new Date().toISOString().slice(0, 10);
  const fullFileName = `${fileName}_${timestamp}.xls`;

  saveAs(blob, fullFileName);
};
